import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteContext = createContext({ site: null, reload: () => {} });

export function isPreview() {
  const p = new URLSearchParams(window.location.search).get("preview");
  if (p === "1") sessionStorage.setItem("bo_preview", "1");
  if (p === "0") sessionStorage.removeItem("bo_preview");
  return sessionStorage.getItem("bo_preview") === "1";
}

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const reload = useCallback(() => api.get("/site", { params: isPreview() ? { preview: true } : {} }).then(({ data }) => setSite(data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return <SiteContext.Provider value={{ site, reload }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);

export function PreviewBar() {
  const { site } = useSite();
  if (!site?.preview) return null;
  const leave = () => { sessionStorage.removeItem("bo_preview"); window.location.href = "/admin"; };
  return (
    <div className="sticky top-0 z-[60] flex items-center justify-center gap-3 bg-bo-yellow px-4 py-2 text-sm font-semibold text-bo-ink" data-testid="preview-bar">
      Pré-visualização do rascunho: os visitantes ainda veem a versão publicada.
      <button onClick={leave} className="rounded-full bg-bo-ink px-3 py-1 text-xs text-white" data-testid="preview-exit-btn">Sair da pré-visualização</button>
    </div>
  );
}
